import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

interface InitialState {
    categoryList: any;
    categoryLoading: boolean;
}
const initialState: InitialState = {
    categoryList: [],
    categoryLoading: false,
};

const categorySubstanceSlice = createSlice({
    name: "eventmap",
    initialState,
    reducers: {
        categoryList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            categoryList: action.payload,
        }),
        setCateLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
            ...state,
            categoryLoading: action.payload,
        }),
    }
})

export const { categoryList, setCateLoader } = categorySubstanceSlice.actions;

export default categorySubstanceSlice.reducer;